/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_Ends_SuccessInputs */

const en_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to event ends finished successfully`)
};

const fr_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignement sur la fin des événements terminé avec succès`)
};

const de_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap to event ends erfolgreich abgeschlossen`)
};

const it_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'aggancio alla fine dell'evento è stato completato con successo`)
};

const ru_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимок экрана для завершения мероприятия успешно завершен.`)
};

const es_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustar al evento finaliza correctamente`)
};

const zh_cn2_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快照事件结束已成功完成`)
};

const ja_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント終了時のスナップが正常に完了しました`)
};

const hi_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्नैप टू इवेंट सफलतापूर्वक समाप्त हो गया`)
};

const pt_pt2_snap_to_event_ends_success = /** @type {(inputs: Snap_To_Event_Ends_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O evento Snap to Event foi concluído com sucesso.`)
};

/**
* | output |
* | --- |
* | "Snap to event ends finished successfully" |
*
* @param {Snap_To_Event_Ends_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_ends_success = /** @type {((inputs?: Snap_To_Event_Ends_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_Ends_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_snap_to_event_ends_success(inputs)
	if (locale === "de") return de_snap_to_event_ends_success(inputs)
	if (locale === "it") return it_snap_to_event_ends_success(inputs)
	if (locale === "ru") return ru_snap_to_event_ends_success(inputs)
	if (locale === "es") return es_snap_to_event_ends_success(inputs)
	if (locale === "zh-CN") return zh_cn2_snap_to_event_ends_success(inputs)
	if (locale === "ja") return ja_snap_to_event_ends_success(inputs)
	if (locale === "hi") return hi_snap_to_event_ends_success(inputs)
	if (locale === "pt-PT") return pt_pt2_snap_to_event_ends_success(inputs)
	return en_snap_to_event_ends_success(inputs)
});